module.exports = __webpack_public_path__ + "resources/img/solution_finance_cloud2_m.af5b7c6e2c6d2c707c339407f4a4e2d9.png";